import queryString from 'query-string'
import { Location } from 'react-router-dom'
import { IView } from '../types/views'

const get = (param: string) => (
  { search }: Location<any>,
  defaultValue?: string
): string | undefined => {
  const value = queryString.parse(search)[param] || defaultValue
  if (typeof value === 'object') {
    return value[0] || defaultValue
  }
  return value
}

export const getTab = get('tab')

export const getEdition = get('edition')

export const isHidden = ({ location, tab, edition }: IView): boolean =>
  (tab !== undefined && tab !== getTab(location)) ||
  (edition !== undefined && edition !== getEdition(location))

interface IParams {
  [param: string]: any
}

export const setSearch = (
  { search }: Location<any>,
  params: IParams
): IParams => ({
  search: queryString.stringify({ ...queryString.parse(search), ...params }),
})

export const updateQuery = (params: IParams) => (
  location: Location<any>
): string => `${location.pathname}?${setSearch(location, params).search}`
